import React, { useState } from 'react';
import styles from './ContactsPage.module.css';
import Header from '../../components/Header/Header';
import { HeaderType } from '../../components/Header/types/Header';
import TabButton from '../../components/UI/TabButton/TabButton';
import Footer from '../../components/Footer/Footer';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

interface AddressInfoProps {
  title?: string;
}

const AddressInfo = ({ title }: AddressInfoProps) => {
  const MapImg = require('../../assets/images/ContactsMap.png');
  const PlaceImg = require('../../assets/images/ContactsPhoto.png');

  return (
    <div className={styles.address_info}>
      {title && <p className={cn('text_subheaders_sh1', styles.office_title)}>{title}</p>}
      <div className={styles.address_track}>
        <div className={styles.address_blocks}>
          <div className={styles.address_block}>
            <p className={cn('text_captions_c2', styles.block_title)}>Адрес</p>
            <p className={cn('text_body_b1', styles.block_info_text)}>
              Каспийск,
              <br />
              проспект Омарова, 8
            </p>
          </div>
          <div className={styles.address_block}>
            <p className={cn('text_captions_c2', styles.block_title)}>График работы</p>
            <p className={cn('text_body_b1', styles.block_info_text)}>
              пн-пт: 09:00–18:30
              <br />
              сб-вс: 09:00–17:00
            </p>
          </div>
          <div className={styles.address_block}>
            <p className={cn('text_captions_c2', styles.block_title)}>Телефон</p>
            <p className={cn('text_body_b1', styles.block_info_text)}>+7 938 151-22-22</p>
          </div>
          <div className={styles.address_block}>
            <p className={cn('text_captions_c2', styles.block_title)}>Почта</p>
            <p className={cn('text_body_b1', styles.block_info_text)}>info@vostokstroy.com</p>
          </div>
        </div>
      </div>
      <div className={styles.address_images}>
        <img className={styles.address_image} src={MapImg} alt='Карта' />
        <img className={cn(styles.address_image, styles.place_img)} src={PlaceImg} alt='Восток Строй' />
      </div>
    </div>
  );
};

export default function ContactsPage() {
  const [activeTab, setActiveTab] = useState('Главный офис');
  return (
    <>
      <Helmet>
        <title>Контакты | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/contacts" />

        <meta property="og:title" content="Контакты | Восток Строй" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/contacts" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Контакты | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <Header theme={HeaderType.Light} />
      <div className={styles.contacts_page}>
        <div className={styles.wrapper}>
          <div className={styles.title}>
            <h2>Контакты</h2>
          </div>
          <div className={styles.tabs}>
            <TabButton
              isActive={activeTab === 'Главный офис'}
              onClick={() => setActiveTab('Главный офис')}
              theme='light'
            >
              Главный офис
            </TabButton>
            <TabButton
              isActive={activeTab === 'Офисы продаж'}
              onClick={() => setActiveTab('Офисы продаж')}
              theme='light'
            >
              Офисы продаж
            </TabButton>
          </div>
          {activeTab === 'Главный офис' ? (
            <AddressInfo />
          ) : (
            <>
              <AddressInfo title='Офис продаж' />
              <AddressInfo title='Офис продаж' />
            </>
          )}
          <div className={styles.line}></div>
          <div className={styles.details}>
            <h3>Реквизиты</h3>
            <div className={styles.details_content}>
              <div className={styles.detail}>
                <p className={cn('text_captions_c2', styles.detail_title)}>Наименование</p>
                <p className={cn('text_body_b1', styles.detail_text)}>ООО «СЗ «ВОСТОК СТРОЙ»</p>
              </div>
              <div className={styles.detail}>
                <p className={cn('text_captions_c2', styles.detail_title)}>адрес</p>
                <p className={cn('text_body_b1', styles.detail_text)}>
                  368300, Россия, Республика Дагестан, город Каспийск, улица проспект Омарова, 8
                </p>
              </div>
              <div className={styles.detail}>
                <p className={cn('text_captions_c2', styles.detail_title)}>инн</p>
                <p className={cn('text_body_b1', styles.detail_text)}>7725790373</p>
              </div>
              <div className={styles.detail}>
                <p className={cn('text_captions_c2', styles.detail_title)}>огрн</p>
                <p className={cn('text_body_b1', styles.detail_text)}>1137746376910</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer theme='light' />
    </>
  );
}
